import { helpers, React, ts, ui } from '_core';

type ChartProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  file: string;
  fullScreen: boolean;
  title: string;
};

const Chart = ({ id, readOnly, loadWidgetData, file, fullScreen, title }: ChartProps) => {
  const [data, setData] = React.useState<ts.types.widgets.TableData>(null);
  const [error, setError] = React.useState<ts.types.common.ApiError>(null);

  const loadData = async () => {
    try {
      const response = await loadWidgetData({
        data: {
          file,
          rename: {
            build_date: 'date',
            forecast_risk: 'Forecast Risk',
            realized_risk: 'Realized Risk',
          },
        },
      });
      if (response) setData(response.data);
    } catch (err) {
      setError(err as ts.types.common.ApiError);
    }
  };

  React.useEffect(() => {
    if (file) loadData();
    return () => setData(null);
  }, [file]);

  return (
    <ui.LineChart
      id={id}
      data={data}
      fullScreen={fullScreen}
      yAxisLabel="Annualized Portfolio Risk"
      readOnly={readOnly}
      alert={error ? { type: 'error', message: helpers.parseApiError(error) } : undefined}
      exportTitle={title}
      numberFormat="#.##%"
    />
  );
};

export default Chart;
